import { Headphones, Languages, TextCursorInput } from 'lucide-react';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { cn } from '@/lib/utils';
import { useLanguage } from '@/i18n/LanguageContext';

export type OutputMode = 'text' | 'voice' | 'both';

interface OutputModeSelectorProps {
  className?: string;
  value: OutputMode;
  onValueChange: (value: OutputMode) => void;
  voiceOnlyDisabled?: boolean;
}

const OutputModeSelector = ({ className, value, onValueChange, voiceOnlyDisabled = false }: OutputModeSelectorProps) => {
  const { t } = useLanguage();

  return (
    <div className={cn('space-y-1.5', className)}>
      <p className="text-xs sm:text-sm font-medium text-foreground">{t('output.label')}</p>
      <Tabs value={value} onValueChange={(next) => onValueChange(next as OutputMode)}>
        <TabsList className="grid h-11 w-full grid-cols-3 rounded-lg bg-secondary/70 p-1">
          <TabsTrigger value="text" className="gap-1.5 text-xs sm:text-sm">
            <TextCursorInput className="h-3.5 w-3.5" />
            {t('output.text')}
          </TabsTrigger>
          <TabsTrigger value="voice" disabled={voiceOnlyDisabled} className="gap-1.5 text-xs sm:text-sm">
            <Headphones className="h-3.5 w-3.5" />
            {t('output.voice')}
          </TabsTrigger>
          <TabsTrigger value="both" className="gap-1.5 text-xs sm:text-sm">
            <Languages className="h-3.5 w-3.5" />
            {t('output.both')}
          </TabsTrigger>
        </TabsList>
      </Tabs>
    </div>
  );
};

export default OutputModeSelector;